/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

import { ModelOfUser } from 'src/database';

import api from '../../services/api';

const initialValuesOfUser = {
	NOME: '',
	LOGIN: '',
	ID: '',
	SENHA: '',
};

export const useListUserController = () => {
	const [UserData, setUserData] = useState<ModelOfUser[]>([]);
	const [AllUserData, setAllUserData] = useState<ModelOfUser[]>([]);
	const [selectedUser, setSelectedUser] = useState<ModelOfUser>(initialValuesOfUser);
	const [editDialog, setEditDialog] = useState(false);
	const [passwordDialog, setPasswordDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);

	const toast: any = useRef();
	const { userAgencyId } = useAuth();

	const validationSchema = Yup.object().shape({
		LOGIN: Yup.string().email('* Informe um email válido').required('* Campo obrigatório'),
	});

	const getAllUsers = () => {
		setLoading(true);
		api.get(`users/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setAllUserData(data);

				setLoading(false);
			})
			.catch((response: AxiosResponse<any>) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const getUsers = () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post(`users2`, { ROW: rows })
			.then(response => {
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setUserData(
						UserData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							}),
						),
					);
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse<any>) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeUser = (user: ModelOfUser) => {
		setLoading(true);
		api.delete(`users/${user.ID}`)
			.then(response => {
				const newList = UserData.filter(user => user.ID !== response.data.ID);
				setUserData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O produto foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getUsers();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const openDeleteDialog = (User: ModelOfUser) => {
		setDeleteDialog(true);
		setSelectedUser(User);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (User: ModelOfUser) => {
		setEditDialog(true);
		setSelectedUser(User);
	};

	const showPassword = (User: ModelOfUser) => {
		setPasswordDialog(true);
		setSelectedUser(User);
	};

	const closePasswordDialog = () => {
		setPasswordDialog(false);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const editUser = (User: ModelOfUser) => {
		setLoadingEdit(true);

		const editedUser: ModelOfUser = {
			LOGIN: User.LOGIN,
		};

		api.put(`users/${selectedUser?.ID}`, editedUser)
			.then(() => {
				// getUsers();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A unidade foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				console.log(err);
				getUsers();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const formik = useFormik<ModelOfUser>({
		initialValues: {
			LOGIN: '',
		},
		onSubmit: async values => await editUser(values),
		validationSchema,
	});

	useEffect(() => {
		getUsers();
	}, [rows]);

	useEffect(() => {
		getAllUsers();
	}, []);

	return {
		getUserListController: {
			toast,
			formik,
			editDialog,
			AllUserData,
			UserData,
			deleteDialog,
			loadingEdit,
			rows,
			maxData,
			selectedUser,
			passwordDialog,
			loadingRows,
			loading,
		},
		handleUserListController: {
			formik,
			showPassword,
			closePasswordDialog,
			closeDeleteDialog,
			openDeleteDialog,
			removeUser,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
